/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Person/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import Avatar from 'DesignSystem/Avatar/index'
import React from 'react'
import Relationships from './Relationships/index'
import Roles from './Roles/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Person({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Email/NewEmail/Content/SearchForEmail/Content/Content/Person",
  presignedUrl
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let personValueData = fromData.useDataFormat({ viewPath,
context: 'person',
format: fromFormat.initials,
})
let personValueData1 = fromData.useDataFormat({ viewPath,
context: 'person',
format: fromFormat.personName,
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Person.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Person.Horizontal:1"
  data-view-path={viewPath}
 style={{'--pt-1-Z2fMjSV': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal1}`}
>
<Avatar
  viewPath={`${viewPath}/Avatar`}
 profile_url={presignedUrl}
 data="person"
 format="/Data/format.js initials"
 initials={personValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXs}
 paddingTop={dtSpaceXs}
 data="person"
 format="/Data/format.js personName"
 text={personValueData1}
/>
</div>
<div
  data-testid="Person.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<Relationships
  viewPath={`${viewPath}/Relationships`}
/>
<Roles
  viewPath={`${viewPath}/Roles`}
/>
</div>
</div>
{children}
</React.Fragment>)
}